export const DROUGHT_FILTER_ITEMS = [
    { value: 'drought', label: 'Aszály' },
    { value: 'daily-t', label: 'napi T' },
    { value: 'daily-mm', label: 'napi mm' },
    { value: 'precip-30d', label: '30 napos mm' },
    { value: 'hot-days-gt-31', label: 'T>31°C' },
];

export const DEFAULT_DROUGHT_FILTER = DROUGHT_FILTER_ITEMS[0].value;
